import { render, staticRenderFns } from "./redirector.vue?vue&type=template&id=013c9699&scoped=true&"
import script from "./redirector.vue?vue&type=script&lang=js&"
export * from "./redirector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013c9699",
  null
  
)

export default component.exports